<div>
  <mat-card-header>
    <div style="width:90%">
      <mat-card-title>
        <label style="padding-top: 15px; font-size: 20px; font-weight: 500; color: #434a54;">Produtos/Serviços</label>
      </mat-card-title>
    </div>
    <div style="width:10%; cursor:pointer;">
      <mat-icon class="btnCancel" style="position: relative; float: right; margin-right: 5px" (click)="closePopup()">cancel</mat-icon>
    </div>
  </mat-card-header>

  <form [formGroup]="prodForm">
    <mat-progress-bar class="progress-bar" mode="indeterminate" *ngIf="showProgressBar"></mat-progress-bar>
    <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
      <mat-radio-group [(ngModel)]="tipoPesquisa" name="rdlPesquisa" formControlName="frmTipoPesquisa">
        <mat-radio-button fxFlex="20%" value="1">CNAE/NCM</mat-radio-button>
        <mat-radio-button fxFlex="20%" value="2">Código do Material</mat-radio-button>
        <mat-radio-button fxFlex="20%" value="3">Descrição</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
      <mat-form-field fxFlex="85%">
        <input type="text" matInput name="descProduto" [(ngModel)]="termoPesquisaProduto" placeholder="Informe os dados do produto/material" formControlName="frmDescProduto" />
      </mat-form-field>

      <div>
        <button mat-button color="primary" style="padding: 0px;float: right;margin-top: 5px;" class="btn-primary" (click)="pesquisar()">
          Pesquisar
        </button>
      </div>
    </div>


    <div style="padding-left: 80%">
      <mat-form-field style="width:100%">
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtrar">
      </mat-form-field>
    </div>

    <div style="padding-left: 50%; float: right;" class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
      <mat-radio-group [(ngModel)]="tipoBusca" name="rdlTipoBusca" formControlName="frmTipoBusca">
        <mat-radio-button fxFlex="90%" value="R" checked="true">Materiais Recorrentes</mat-radio-button>
        <mat-radio-button fxFlex="90%" value="T">Todos os Materiais</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="table-container">
      <table mat-table [dataSource]="dataSource" matSort style="width:100%;">
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row; let i = index;">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row, i)">
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="cnae">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> CNAE/NCM </th>
          <td mat-cell *matCellDef="let element"> {{element.cnae}} </td>
        </ng-container>

        <ng-container matColumnDef="codigoMaterial">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Código Material </th>
          <td mat-cell *matCellDef="let element"> {{element.idSapProduto}} </td>
        </ng-container>

        <ng-container matColumnDef="descricao">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Descrição </th>
          <td mat-cell *matCellDef="let element">{{element.descricao}} </td>
        </ng-container>

        <ng-container matColumnDef="contacontabil">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Conta Contábil </th>
          <td mat-cell *matCellDef="let element"> {{element.contaContabil}} </td>
        </ng-container>

        <ng-container matColumnDef="contrato">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Contrato </th>
          <td mat-cell *matCellDef="let element"> {{element.contrato}} </td>
        </ng-container>

        <ng-container matColumnDef="ipi">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> IPI </th>
          <td mat-cell *matCellDef="let element"> {{element.ipi}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
    <mat-paginator [pageSizeOptions]="[5, 50, 100, 500, 1000]" showFirstLastButtons></mat-paginator>

    <mat-action-row class="footer">
      <button mat-button color="primary" class="btn-primary extra-large" (click)="incluirProdutos()">INCLUIR
        PRODUTO(S)</button>
    </mat-action-row>
  </form>
</div>